import { useWindowSize } from '@common/../lib-components/Carousel';
import { SliderSliceType } from '@common/store/slider/slice';
import { getLambdaLink, isMobile } from '@common/utils';

interface Slider {
  slider: number;
  image: string;
  heading: string;
  subheading: string;
  link: string;
  type: string;
  label?: string;
  showCustomText: boolean;
  showButton: boolean;
  isVisible?: boolean;
}

export const processResponse = (slider: Record<string, unknown>): Slider => {
  const { width, height } = isMobile() ? { width: 0, height: 0 } : { width: 0, height: 0 };
  return {
    slider: slider.id as number,
    image: slider.image ? getLambdaLink({ link: slider.image as string, width, height }) : null,
    heading: slider.show_custom_text ? (slider.heading as string) : '',
    subheading: slider.show_custom_text ? (slider.sub_heading as string) : '',
    link: slider.show_button ? (slider.button_link as string) : '',
    type: slider.slider_type as string,
    label: slider.show_button ? ((slider.button_label || 'Shop Now') as string) : '',
    showCustomText: slider.show_custom_text as boolean,
    showButton: slider.show_button as boolean,
    isVisible: slider.is_visible as boolean,
  };
};

export default Slider;

export const getFilteredSliderImages = ({
  slider,
  shouldImageBePresent,
}: {
  slider: SliderSliceType;
  shouldImageBePresent?: boolean;
}): Slider[] => {
  let filteredImages = slider.slider?.filter(
    (item) => (item?.image || item?.heading || item?.subheading) && !item?.delete && item?.isVisible,
  );
  const { width } = useWindowSize();
  if (width <= 768) {
    filteredImages = filteredImages?.filter((item) => item?.type != 2);
  } else {
    filteredImages = filteredImages?.filter((item) => item?.type != 3);
  }

  if (shouldImageBePresent) {
    filteredImages = filteredImages?.filter((item) => item?.image);
  }
  return filteredImages;
};
